import React from 'react';
import { Mail } from 'lucide-react';
import CivicModal from './CivicModal';
import { useApp } from '../lib/AppContext';

interface ContactCivicbeatModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function ContactCivicbeatModal({
  isOpen,
  onClose,
}: ContactCivicbeatModalProps) {
  const { navigateTo } = useApp();

  const handleFeedbackClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClose();
    navigateTo('feedback');
  };

  return (
    <CivicModal
      isOpen={isOpen}
      onClose={onClose}
      title="Contact civicbeat"
      icon={Mail}
      maxWidth="md"
    >
      <div
        className="bg-[#1A1A1A] rounded-xl border"
        style={{
          borderColor: 'rgba(255, 255, 255, 0.08)',
          padding: '32px 24px',
        }}
      >
        <div className="space-y-4">
          <p
            className="text-[#E0E0E0]"
            style={{
              fontSize: '14px',
              lineHeight: '1.65',
            }}
          >
            civicbeat is an evolving project exploring how music shapes the way we understand power, culture, and civic life.
          </p>

          <p
            className="text-[#E0E0E0]"
            style={{
              fontSize: '14px',
              lineHeight: '1.65',
            }}
          >
            If you'd like to reach out about collaborations, research, media, or the project itself, feel free to get in touch.
          </p>

          <div className="pt-2 pb-2">
            <a
              href="mailto:hello@civicbeat.org"
              className="flex items-center gap-2.5 text-[#40E0D0] hover:text-[#52E3C2] transition-colors group"
              style={{
                fontSize: '15px',
              }}
            >
              <span className="text-[18px] flex-shrink-0">📧</span>
              <span className="font-medium">hello@civicbeat.org</span>
            </a>
          </div>

          <p
            className="text-[#E0E0E0]"
            style={{
              fontSize: '14px',
              lineHeight: '1.65',
            }}
          >
            Every message is read thoughtfully, even if we can't respond to all of them.
          </p>

          <p
            className="text-[#E0E0E0]"
            style={{
              fontSize: '14px',
              lineHeight: '1.65',
            }}
          >
            For ideas, feature requests, or technical feedback, please use the{' '}
            <button
              onClick={handleFeedbackClick}
              className="text-[#40E0D0] hover:text-[#52E3C2] transition-colors underline decoration-[#40E0D0]/30 hover:decoration-[#52E3C2]/50 underline-offset-2"
            >
              Share Feedback
            </button>{' '}
            form so your suggestions can help shape the platform.
          </p>
        </div>
      </div>
    </CivicModal>
  );
}
